import React from "react";

// Material UI
import SvgIcon from "@material-ui/core/SvgIcon";

const LayerTypePolygonIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1C3.88191 1 4.65554 1.45771 5.10059 2.14746L15.1133 2.8623C15.5716 2.3347 16.2462 2 17 2C18.3807 2 19.5 3.11929 19.5 4.5C19.5 5.60761 18.779 6.54477 17.7812 6.87305L17.209 14.3125C17.9785 14.7387 18.5 15.558 18.5 16.5C18.5 17.8807 17.3807 19 16 19C15.183 19 14.4601 18.6061 14.0039 18H6.99609C6.5399 18.6061 5.81703 19 5 19C3.61929 19 2.5 17.8807 2.5 16.5C2.5 15.6294 2.94509 14.8627 3.62012 14.415L2.40723 5.92578C1.31305 5.65933 0.5 4.67618 0.5 3.5C0.5 2.11929 1.61929 1 3 1ZM5.40527 4.17285C5.24191 4.75808 4.87308 5.25634 4.37891 5.58398L5.5918 14.0732C6.52724 14.3006 7.25766 15.0514 7.4502 16H13.5498C13.7291 15.1167 14.3746 14.4036 15.2178 14.126L15.79 6.68652C15.1109 6.30993 14.6265 5.62742 14.5225 4.82422L5.40527 4.17285Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default LayerTypePolygonIcon;
